// extracted by mini-css-extract-plugin
export default {"channelCard":"_2-1EC","description":"R2zVY","button":"_2PJDq"};